<template>
  <div class="w-full p-1 justify-between flex bg-[#F8F8F8]">
    <div>
      <div class="font-bold capitalize text-[16px]">
        Komchat {{ currentPackage }}
      </div>
      <div class="flex gap-2 items-center">
        <div>
          <b-icon
            class="mr-[5px] text-lg"
            icon="arrow-return-right"
          />Notif Pengiriman
        </div>
        <div>
          <b-button
            v-if="badge === 'Regular' ? expiredAt !== 0 : levelPackage > 1 && expiredAt !== 0 "
            variant="outline-primary"
            size="sm"
            @click="handleClick('extends')"
          >
            Perpanjang</b-button>
        </div>
      </div>
      <div class="flex gap-1 ml-[1.3rem] items-center">
        <span
          :class="expiredAt !== 0? 'bg-[#34A770]' : 'bg-primary'"
          class="h-2 rounded-lg block w-2"
        /> <span v-if="badge !== 'Regular' && levelPackage < 2">Unlimited</span> <span v-else-if="expiredAt !== 0">Expired : {{ expiredAt }} Hari Lagi </span> <span v-else>Fitur Telah Expired</span>
      </div>
    </div>
    <div class="">
      <b-button
        v-if="expiredAt === 0? true : expiredAt !== 0 && levelPackage < 3"
        variant="primary"
        size="sm"
        @click="handleClick(expiredAt !== 0 && currentPackage?'upgrade': 'subscrabe')"
      >
        <span v-if="expiredAt !== 0 && levelPackage < 3 ">Upgrade Package</span>
        <span v-if="expiredAt === 0">Aktifkan</span>
      </b-button>
    </div>
    <extendSubscribeModal :curent-package="currentPackage" />
    <komchatPricingModal
      :re-activate="isReactivate"
      :is-upgrade="isUpgrade"
      :package-level="levelPackage"
    />
    <komchatPricingModalNew
      :re-activate="isReactivate"
      :is-upgrade="isUpgrade"
      :package-level="levelPackage"
    />
  </div>
</template>
<script>
import extendSubscribeModal from '../opsional/modal/extend-subscribe-modal.vue'
import komchatPricingModal from '../opsional/modal/komchat-pricing-modal.vue'
import komchatPricingModalNew from '../opsional/modal/komchat-pricing-modal-new.vue'

export default {
  components: {
    extendSubscribeModal,
    komchatPricingModal,
    komchatPricingModalNew,
  },
  props: {
    dataSubscribe: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      isUpgrade: false,
      isReactivate: false,
      badge: this.$store.state.whatsapp.check_wa.is_user_type,
    }
  },
  computed: {
    currentPackage() {
      return this.$store.state.whatsapp.dashboard_wa?.subscription_plan_category
        ?? this.dataSubscribe.subscription_plan_category
    },
    levelPackage() {
      return this.$store.state.whatsapp.dashboard_wa?.subscription_plan_level
        ?? this.dataSubscribe.subscription_plan_level
    },
    expiredAt() {
      return this.$store.state.whatsapp.dashboard_wa?.whatsapp_expired_at
        ?? this.dataSubscribe.whatsapp_expired_at
    },
  },
  methods: {
    async handleClick(value) {
      if (value === 'extends') {
        await this.$store.dispatch('komchat/getSubsPlanList')
        await this.$store.dispatch('whatsapp/getUpdateDashboardWa')
        this.$bvModal.show('modal-extends-subcription')
      } else if (value === 'upgrade') {
        this.isUpgrade = true
        this.$bvModal.show('modal-pricing-komchat')
      } else if (value === 'subscrabe') {
        this.isReactivate = true
        this.$bvModal.show('modal-pricing-komchat')
      }
    },
  },
}
</script>
